module.exports = __webpack_public_path__ + "img/fileUpload.efea0851.svg";